import { Button } from "@chakra-ui/react";

import { StepDetailsBaseProps } from "../../models/StepDetailsBaseProps";
import { StepStateModel } from "../../models/StepModel";

 
export const PortfolioMarketModelStep = (props: StepDetailsBaseProps) => {
    const {
        colorScheme = 'blue', 
        className,
        style,
        children,
        saveActiveStepState,
        stepsSavedState,
        title,
        description,
        stepIdx,
        selectedStepOptionValue, // the value of the selected option
        stepOptions,
        setIsStepValid,
    } = props;



    const stepState: StepStateModel = { 
        stepIdx,
        selectedItems: [
            {itemTypeId: 1, itemId: 2, itemName: "MMM 2"}, 
            //{itemTypeId: 1, itemId: 4, itemName: "item M"}
        ], // the selected items for this step
    };


    const renderStepContent = () =>  {
        console.log({...props, stepsSavedState});

        return (
            <>
                <h4>{ `${props.title}` }</h4>

                <>
                    <p>Please select one Main Market Model:</p>
                    <ul>
                        <li>MMM 1</li>
                        <li>Selected: MMM 2</li>
                        <li>MMM 3</li>
                        <li>MMM 4</li>
                    </ul>
                </>
                
                <Button onClick={() => {
                    saveActiveStepState(stepIdx, stepState); 
                    setIsStepValid(true);
                    }}
                    >Simulating MMM is selected and valid</Button>

            </>
        );
    }

    return renderStepContent()
 
}


